export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-br from-foreground-900 to-foreground-800 rounded-2xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-accent-500 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-primary-500 rounded-full blur-3xl"></div>
          </div>

          <div className="relative flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-400 bg-primary-500/20 rounded-full mb-3">
              APP下载
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              下载90影视APP · 观影更便捷
            </h2>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              90影视APP支持Android与iOS双平台，提供更稳定的播放体验、离线缓存、智能推荐与投屏功能。无广告纯净观影，最新资源第一时间推送。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a href="#app" className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-100 text-foreground-900 font-semibold text-sm rounded-lg transition-all duration-200">
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </a>
              <a href="#app" className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 hover:bg-background-50/30 border border-background-50/30 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200">
                <i className="ri-apple-line text-lg"></i>
                iOS 下载
              </a>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-foreground-400">
              <span><i className="ri-check-line mr-1"></i>无广告纯净观影</span>
              <span><i className="ri-check-line mr-1"></i>离线缓存随时看</span>
              <span><i className="ri-check-line mr-1"></i>智能推荐找片快</span>
            </div>
          </div>

          <div className="relative shrink-0">
            <div className="w-44 md:w-52 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/20 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20app%20mockup%20displaying%20movie%20streaming%20interface%20with%20warm%20dark%20theme%2C%20film%20poster%20thumbnails%20grid%2C%20golden%20amber%20accent%20UI%20elements%2C%20minimal%20design%2C%20no%20text%20labels%2C%20clean%20modern%20layout%2C%20cinematic%20color%20palette&width=600&height=1067&seq=app-mockup-01&orientation=portrait"
                alt="90影视APP移动端界面展示"
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}